export default __webpack_public_path__ + "static/media/ticketing.3e19187c.svg";